import cx from "classnames";
import { Fragment } from "react";
import { Container } from "react-grid-system";

import { Link as DSLink } from "@icg360/design-system";

import SagesureLogoFooter from "images/sagesure-logo-footer.svg?react";

import styles from "./page-footer.module.scss";

const footerBaseLinks = [
  {
    link: "https://www.sagesure.com/about/",
    text: "About",
    id: "aboutBtn",
  },
  {
    link: "https://www.sagesure.com/faq/",
    text: "FAQs",
    id: "faqBtn",
  },
  {
    link: "/terms-of-use",
    text: "Terms",
    id: "termsBtn",
  },
  {
    link: "/privacy-policy",
    text: "Privacy",
    id: "privacyBtn",
  },
];

const footerAuthenticatedLinks = footerBaseLinks.filter(
  ({ text }) => text !== "FAQs",
);

type PageFooterProps = {
  className?: string;
  unauthenticated?: boolean;
};

export const PageFooter = ({ className, unauthenticated }: PageFooterProps) => {
  const footerLinks = unauthenticated
    ? footerBaseLinks
    : footerAuthenticatedLinks;
  return (
    <footer className={cx(styles.footerWrapper, className)}>
      <div className={styles.container}>
        <Container>
          <div className={styles.flexWrapper}>
            <div className={styles.msslogo}>
              <SagesureLogoFooter />
            </div>
            <div className={styles.content}>
              <span
                className={styles.text}
              >{`© ${new Date().getFullYear()} SageSure`}</span>
              <span className={styles.bar}>|</span>
              <ul className={styles.sitemap}>
                {footerLinks.map((footerLink, index) => (
                  <Fragment key={index}>
                    <li>
                      <DSLink
                        href={footerLink.link}
                        id={footerLink.id}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={index}
                      >
                        {footerLink.text}
                      </DSLink>
                    </li>
                    {index !== footerLinks.length - 1 ? "|" : " "}
                  </Fragment>
                ))}
              </ul>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};
